import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { ComponentsModule } from '../../components/components.module';
import { OpsTabsPage } from './ops-tabs';

@NgModule({
  declarations: [OpsTabsPage],
  imports: [IonicPageModule.forChild(OpsTabsPage), ComponentsModule],
})
export class OpsTabsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/ops-tabs/ops-tabs.module.ts